import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import get from 'lodash.get';
import {
    Grid,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Paper,
} from '@material-ui/core';

import { NO_PATH } from 'yeself-common/cssPath';

import { updateDetailSettings } from 'Console/data/applicationDetail/settings/SettingsAction';

import { selectApplicationEditorSettings } from 'Console/data/applicationDetail/settings/SettingsSelector';

import FormInput from 'Console/components/common/form/FormInput';
import FormCheckbox from 'Console/components/common/form/FormCheckbox';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        padding: '0 24px',
        fontSize: theme.typography.pxToRem(14),
    },
    title: {
        display: 'inline-block',
        fontWeight: 'bold',
        paddingBottom: theme.spacing.unit * 2 + 4,
    },
    message: {
        fontSize: theme.typography.pxToRem(14),
        paddingBottom: theme.spacing.unit * 3 + 1,
    },
    paper: {
        width: '100%',
        overflowX: 'auto',
        [theme.breakpoints.down('xs')]: {
            width: window.innerWidth * 0.7,
            overflow: 'scroll',
        },
    },
    paper2: {
        extend: 'paper',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        width: '100%',
    },
    tableItem: {
        textAlign: 'right',
    },
    tableItem2: {
        textAlign: 'left',
        width: '20.5625rem',
    },
    btn: {
        marginTop: theme.spacing.unit * 2 + 4,
        marginBottom: theme.spacing.unit * 5,
    },
    formInput: {
        width: '47%',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            marginTop: '5%',
        },
    },
});

class GuideDefaults extends Component {
    handleSaveSettings = () => {
        const {
            form: { getFieldValue },
            updateDetailSettings,
        } = this.props;

        const {
            navigate,
            notCovered,
            ignoreNavigation,
            ignoreQueryParameters,
            scrollToStep,
            updateOnScroll,
            location,
        } = getFieldValue('defaults');

        updateDetailSettings(
            {
                'editorSettings.defaults.node.navigation.ignoreNavigation': ignoreNavigation,
                'editorSettings.defaults.node.navigation.ignoreQueryParameters': ignoreQueryParameters,
                'editorSettings.defaults.node.navigation.navigate': navigate,
                'editorSettings.defaults.node.position.notCovered': notCovered,
                'editorSettings.defaults.node.position.scrollToStep': scrollToStep,
                'editorSettings.defaults.node.position.updateOnScroll': updateOnScroll,
                'editorSettings.defaults.node.position.container.location': location,
            },
            {
                success: (
                    <FormattedMessage id="Notification.save" defaultMessage="Your settings were saved" />
                ),

                fail: (
                    <FormattedMessage
                        id="Notification.fail"
                        defaultMessage="Unable to save, something went wrong"
                    />
                ),
            }
        );
    };

    render() {
        const { classes, intl, form, editorSettings } = this.props;

        return (
            <Grid className={classes.root}>
                <Grid item>
                    <Typography variant="subtitle1" className={classes.title}>
                        <FormattedMessage
                            id="Settings.defaults.guideDefaults"
                            defaultMessage="Guide defaults"
                        />
                    </Typography>
                </Grid>

                <Grid item>
                    <Typography variant="body1" className={classes.message}>
                        <FormattedMessage
                            id="Settings.defaults.message"
                            defaultMessage="Here you can set the default values for steps in your guides. Changes here will be reflected in newly created guides only."
                        />
                    </Typography>
                </Grid>

                <Grid item>
                    <Typography variant="subtitle1" className={classes.title}>
                        <FormattedMessage
                            id="Settings.defaults.nodeDefaults"
                            defaultMessage="Overlay Defaults"
                        />
                    </Typography>
                </Grid>

                <Grid id="yeself-guide-default" container>
                    <Paper className={classes.paper}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow id="yeself-guide-default-table-row">
                                    <TableCell>
                                        <FormattedMessage
                                            id="Settings.defaults.navigate"
                                            defaultMessage="Navigate to URL address when step is shown"
                                        />
                                    </TableCell>
                                    <TableCell
                                        id="yeself-guide-default-table-item"
                                        className={classes.tableItem}
                                    >
                                        <FormCheckbox
                                            initialValue={get(
                                                editorSettings,
                                                'defaults.node.navigation.navigate'
                                            )}
                                            form={form}
                                            formItemKey="defaults.navigate"
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow id="yeself-guide-default-table-row">
                                    <TableCell>
                                        <FormattedMessage
                                            id="Settings.defaults.ignoreNavigation"
                                            defaultMessage="Ignore URL address"
                                        />
                                    </TableCell>
                                    <TableCell
                                        id="yeself-guide-default-table-item"
                                        className={classes.tableItem}
                                    >
                                        <FormCheckbox
                                            initialValue={get(
                                                editorSettings,
                                                'defaults.node.navigation.ignoreNavigation'
                                            )}
                                            form={form}
                                            formItemKey="defaults.ignoreNavigation"
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow id="yeself-guide-default-table-row">
                                    <TableCell>
                                        <FormattedMessage
                                            id="Settings.defaults.ignoreQueryParameters"
                                            defaultMessage="Ignore recorded query parameters"
                                        />
                                    </TableCell>
                                    <TableCell
                                        id="yeself-guide-default-table-item"
                                        className={classes.tableItem}
                                    >
                                        <FormCheckbox
                                            initialValue={get(
                                                editorSettings,
                                                'defaults.node.navigation.ignoreQueryParameters'
                                            )}
                                            form={form}
                                            formItemKey="defaults.ignoreQueryParameters"
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow id="yeself-guide-default-table-row">
                                    <TableCell>
                                        <FormattedMessage
                                            id="Settings.defaults.scrollToStep"
                                            defaultMessage="Scroll to view element"
                                        />
                                    </TableCell>
                                    <TableCell
                                        id="yeself-guide-default-table-item"
                                        className={classes.tableItem}
                                    >
                                        <FormCheckbox
                                            initialValue={get(
                                                editorSettings,
                                                'defaults.node.position.scrollToStep'
                                            )}
                                            form={form}
                                            formItemKey="defaults.scrollToStep"
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow id="yeself-guide-default-table-row">
                                    <TableCell>
                                        <FormattedMessage
                                            id="Settings.defaults.notCovered"
                                            defaultMessage="Display step when element is not covered"
                                        />
                                    </TableCell>
                                    <TableCell
                                        id="yeself-guide-default-table-item"
                                        className={classes.tableItem}
                                    >
                                        <FormCheckbox
                                            initialValue={get(
                                                editorSettings,
                                                'defaults.node.position.notCovered'
                                            )}
                                            form={form}
                                            formItemKey="defaults.notCovered"
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>
                </Grid>

                <Grid container>
                    <Paper className={classes.paper2}>
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow id="yeself-guide-default-table-row">
                                    <TableCell>
                                        <FormattedMessage
                                            id="Settings.defaults.updateOnScroll"
                                            defaultMessage="Enable position recalculation when user scrolls"
                                        />
                                    </TableCell>
                                    <TableCell
                                        id="yeself-guide-default-table-item"
                                        className={classes.tableItem}
                                    >
                                        <FormCheckbox
                                            initialValue={get(
                                                editorSettings,
                                                'defaults.node.position.updateOnScroll'
                                            )}
                                            form={form}
                                            formItemKey="defaults.updateOnScroll"
                                        />
                                    </TableCell>
                                </TableRow>

                                <TableRow id="yeself-guide-default-table-row">
                                    <TableCell className={classes.formInput}>
                                        <FormInput
                                            form={form}
                                            fullWidth
                                            isRequired={false}
                                            type="text"
                                            label={intl.formatMessage({
                                                id: 'Settings.defaults.label',
                                            })}
                                            formItemKey="defaults.location"
                                            initialValue={get(
                                                editorSettings,
                                                'defaults.node.position.container.location',
                                                NO_PATH
                                            )}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>
                </Grid>

                <Grid container alignItems="center">
                    <Typography variant="button">
                        <Button
                            id="yeself-button"
                            variant="contained"
                            color="primary"
                            onClick={this.handleSaveSettings}
                            className={classes.btn}
                        >
                            <FormattedMessage id="Buttons.save" defaultMessage="Save" />
                        </Button>
                    </Typography>
                </Grid>
            </Grid>
        );
    }
}

export default connect(
    (state) => ({
        editorSettings: selectApplicationEditorSettings(state),
    }),
    {
        updateDetailSettings,
    }
)(withStyles(styles)(injectIntl(GuideDefaults)));
